import { useState, useEffect } from "react";
import { Typography, Button } from "@mui/material";
import { useLocation, useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import app from '../../services/firebase'



function AccountProfile() {
    const navigate = useNavigate();
    const auth = getAuth(app);
    const location = useLocation()
    const [user, setUser] = useState(null)

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (authUser) => {
            setUser(authUser)
        });

        return () => unsubscribe();
    }, []);

    const handleSignOut = async () => {
        if (window.confirm("Are you sure you want to sign out?")) {
            try {
                await signOut(auth)
                navigate('./');
            } catch (error) {
                console.log(error.message)
            }
        }
    }

    console.log('mobidawg AccountProfile user:', user);

    return(
        <div>
            <Typography variant="h6"  gutterBottom>
            Account Profile
            </Typography>

            {/* Conditional Rendering based on Authentication */}
            {user ? ( // User is signed in
                

                <Typography variant="body1" gutterBottom sx={{ mt:2}}>
                Hi, {user.displayName || user.email}! 
                <br/ >
                Confirm that you want to sign out.
                <br/ >

                <Button variant="contained" onClick={handleSignOut} sx={{ mt:8 , backgroundColor: 'red'}}>
                    Sign Out
                </Button>
                </Typography>

            ) : ( // User is not signed in
                <Button onClick={() => {navigate("/auth/signon")}}>
                    Sign In
                </Button>

            )}

        </div>        
    )
}

export default AccountProfile;
